import { useRef, useState } from 'react'
import './accordion.scss'
import { ReactComponent as Plus } from '../../../assets/footer/plus.svg'

const AccordionButton = ({
  isOpen,
  onClick,
  title,
}: {
  isOpen: boolean
  onClick: () => void
  title: string
}) => {
  const ref = useRef<any>(null)
  return (
    <div
      className={
        isOpen ? 'accordion-item-button open' : 'accordion-item-button'
      }
      onClick={onClick}
    >
      <div className="accordion-item-button__title">{title}</div>
      <div
        className="accordion-item-button__icon button-active"
        ref={ref}
        onClick={() => {
          if (ref.current.classList.contains('button-active')) {
            setTimeout(() => {
              ref.current?.classList.toggle('button-active')
            }, 300)
          } else {
            ref.current?.classList.toggle('button-active')
            setTimeout(() => {
              ref.current?.classList.toggle('button-active')
            }, 300)
          }
        }}
      >
        <Plus />
        {/* <div className="accordion-item-button__icon-line"></div>
        <div className="accordion-item-button__icon-line"></div> */}
      </div>
    </div>
  )
}

const AccordionContent = ({
  isOpen,
  content,
}: {
  isOpen: boolean
  content: string
}) => {
  return (
    <div
      className={
        isOpen ? 'accordion-item-content open' : 'accordion-item-content'
      }
      dangerouslySetInnerHTML={{ __html: content }}
    ></div>
  )
}

const AccordionItem = ({ title, content }: { title: string; content: any }) => {
  const [isItemOpen, setItemOpen] = useState(false)

  return (
    <div className="accordion-item">
      <AccordionButton
        onClick={() => setItemOpen(!isItemOpen)}
        isOpen={isItemOpen}
        title={title}
      />
      <AccordionContent isOpen={isItemOpen} content={content} />
    </div>
  )
}

const Accordion = ({
  items,
}: {
  items: Array<{ title: string; text: string }>
}) => {
  return (
    <div className="accordion">
      {items.map((item, i) => {
        return <AccordionItem title={item.title} content={item.text} key={i} />
      })}
    </div>
  )
}

export default Accordion
